<template>
  <div class="setting">
    <div class="setting-wrap">
      <div @click="onCloseClick" class="close"></div>
      <div class="title">驿站管理</div>
      <div class="types">
        <div
          class="type-item"
          @click="changeType(1)"
          :class="{ active: type == 1 }"
        >
          上网模式
          <div class="corner"></div>
        </div>
        <div
          class="type-item"
          @click="changeType(2)"
          :class="{ active: type == 2 }"
        >
          积分模式
          <div class="corner"></div>
        </div>
      </div>
      <div class="tips-wrap" v-if="type == 1">
        上网模式会优先保障您的上网体验，占用少量的上行带宽。
      </div>
      <div class="tips-wrap tips-wrap2" v-else>
        建议您的网络比较闲置状态使用，会获得更多的积分收益。
      </div>

      <div class="sub-title">
        驿站大小
        <div class="sub-title-tips">驿站越大 积分越多</div>
      </div>
      <div class="size-select">
        <div class="size-bg">
          <div class="size-value" :style="{ width: sizePercent + '%' }"></div>
        </div>
        <div
          @click="changeDiskcache(300)"
          class="point point1"
          :class="{ active: sizePercent >= 0 }"
        ></div>
        <div
          @click="changeDiskcache(400)"
          class="point point2"
          :class="{ active: sizePercent >= 33 }"
        ></div>
        <div
          @click="changeDiskcache(500)"
          class="point point3"
          :class="{ active: sizePercent >= 66 }"
        ></div>
        <div
          @click="changeDiskcache(600)"
          class="point point4"
          :class="{ active: sizePercent >= 99 }"
        ></div>
        <div
          class="size-point"
          :style="{ left: (sizePercent < 1 ? 3 : sizePercent) + '%' }"
        ></div>
      </div>
      <div class="select-tips">
        <div class="item">300G</div>
        <div class="item">400G</div>
        <div class="item">500G</div>
        <div class="item">600G</div>
      </div>
      <div class="sub-title">
        缓存占比
        <div class="clean-btn" @click="cacheCleanClick(4)">清除</div>
      </div>
      <div class="used-percent">
        <div
          class="used-percent-value"
          :style="{ width: cachePercent + '%' }"
        ></div>
      </div>
      <div class="sub-title">缓存路径</div>
      <div class="path">{{ cachedir }}</div>
      <div class="sub-title">
        驿站服务
        <div :class="{ 'btn-open': true }">
          已开启
          <div :class="{ icon: true }"></div>
          <div class="uninstall-btn" @click="showStop">停止</div>
        </div>
      </div>
    </div>
    <Message :myWidth="myWidth" :myHeight="myHeight" v-if="isShowAlert">
      <template v-slot:content>
        <div class="cache-clean-wrap" v-if="settingType == 4">
          <div class="close-btn" @click="hideAlertClick()"></div>
          <img :src="device_icon4" alt="#" />
          <div class="title">清除缓存</div>
          <div class="text-wrap">
            <div class="text1">
              小宝会自动清理过期缓存，手动清除
              <div>缓存会影响积分收益。</div>
            </div>
          </div>
          <div class="clean-btns">
            <div class="clean-btn-cancel" @click="hideAlertClick()">返回</div>
            <div class="clean-btn-sure" @click="cacheCleanClick(6)">清除</div>
          </div>
        </div>
        <div class="do-cache-clean-wrap" v-if="settingType == 5">
          <div class="close-btn" @click="hideAlertClick()"></div>
          <div class="title">清除缓存</div>
          <div class="text-wrap">
            <div class="img-wrap">
              <img :src="device_icon4" alt="#" />
            </div>
            <div class="text1">
              请确定要清除缓存的大小。（清除缓存将按照由旧到新的顺序清除）
            </div>
          </div>
          <div class="cache-clean-options">
            <div :class="{ active: size == 25 }" @click="sizeClick(25)">
              50G
            </div>
            <div
              class="text2"
              :class="{ active: size == 50 }"
              @click="sizeClick(50)"
            >
              100G
            </div>
            <div :class="{ active: size == 100 }" @click="sizeClick(100)">
              全部
            </div>
          </div>
          <div class="clear-cache-btn" @click="doCacheCleanClick()">
            清除缓存
          </div>
        </div>
        <div class="do-cache-clean-wrap" v-if="settingType == 6">
          <div class="close-btn" @click="hideAlertClick()"></div>
          <div class="cleaning-tips">正在清除缓存</div>
          <div class="cleaning-sub-tips">关闭窗口后将继续清理缓存</div>
          <div class="clear-cache-btn" @click="hideAlertClick">确定</div>
        </div>
      </template>
    </Message>
    <StopAlert
      @onSureClick="stopXbyz"
      @onCloseClick="hideStop"
      v-if="isShowStopAlert"
    ></StopAlert>
  </div>
</template>

<script>
import Message from "@/components/Message.vue";
import StopAlert from "@/components/Speed/StopAlert.vue";
import { mapActions } from "vuex";
export default {
  data: function () {
    return {
      sizePercent: 0,
      cachePercent: 0,
      type: 2,
      cacheused: 0,
      cachetotal: 0,
      diskcache: 200,
      switching: 0,
      uploadspeed: 100,
      cachedir: "",
      isShowAlert: false,
      device_icon1: require("../../assets/home/node/device_setting1.svg"),
      device_icon2: require("../../assets/home/node/device_setting2.svg"),
      device_icon3: require("../../assets/home/node/device_setting3.svg"),
      device_icon4: require("../../assets/home/node/device_setting4.svg"),
      myWidth: "369px",
      myHeight: "395px",
      cleanSize: 25, //25清除50G		50清除100G		100清除全部
      isCleaningCache: false,
      isShowStopAlert: false,
    };
  },
  components: { Message, StopAlert },
  watch: {
    type: function (newVal) {
      if (newVal == 1) {
        this.uploadspeed = 50;
      } else {
        this.uploadspeed = 100;
      }
      this.updaetSetting();
    },
    uploadspeed: function (newVal) {
      if (newVal > 50) {
        this.type = 2;
      } else {
        this.type = 1;
      }
      this.updaetSetting();
    },
    diskcache: function (newVal) {
      if (newVal >= 600) {
        this.sizePercent = 100;
      } else if (newVal >= 500) {
        this.sizePercent = 66;
      } else if (newVal >= 400) {
        this.sizePercent = 33;
      } else {
        this.sizePercent = 0;
      }
      this.updaetSetting();
    },
  },
  props: ["pid"],
  methods: {
    ...mapActions(["limitget", "limitset", "cacheclean", "miniappStatus"]),
    stopXbyz: function () {
      let _that = this;
      _that.miniappStatus([
        _that.pid,
        "xbjf",
        0,
        function (err, data) {
          _that.hideStop();
          _that.$emit("onCloseClick");
          _that.$emit("updateSetting");
        },
      ]);
    },
    showStop: function () {
      this.isShowStopAlert = true;
    },
    hideStop: function () {
      this.isShowStopAlert = false;
    },
    onCloseClick: function () {
      this.$emit("onCloseClick");
    },
    changeType: function (type) {
      this.type = type;
    },
    changeSizePercent: function (percent) {
      this.sizePercent = percent;
    },
    changeCacheused: function (cacheused) {
      this.cacheused = cacheused;
    },
    changeDiskcache: function (cache) {
      this.diskcache = cache;
    },
    getSetting: function () {
      let _that = this;
      _that.limitget([
        _that.pid,
        function (err, data) {
          if (data && data.rtn == 0) {
            // for test
            // data.cacheused = 100;

            _that.cachedir = data.cachedir ? data.cachedir : "";
            _that.cacheused = data.cacheused ? data.cacheused : 0;
            _that.diskcache = data.diskcache ? data.diskcache : 0;
            _that.uploadspeed = data.uploadspeed ? data.uploadspeed : 0;
            _that.switching = data.switch && data.switch == 1 ? 1 : 0;
            _that.cachetotal = data.cachetotal ? data.cachetotal : 0;
            _that.cacheleft = data.cacheleft ? data.cacheleft : 0;

            let cacheUsedPercent = 0;
            if (_that.diskcache && _that.cacheused) {
              cacheUsedPercent = parseInt(
                (_that.cacheused / _that.diskcache) * 100
              );
            }

            cacheUsedPercent = cacheUsedPercent > 100 ? 100 : cacheUsedPercent;
            _that.cachePercent = cacheUsedPercent;

            _that.renderCacheBtn();
          }
        },
      ]);
    },
    updaetSetting: function () {
      let _that = this;
      _that.limitset([
        _that.pid,
        _that.diskcache,
        _that.uploadspeed,
        _that.switching,
        null,
        function (err, data) {},
      ]);
    },
    hideCacheCleanClick: function () {
      let _that = this;
      _that.hideAlertClick();
    },
    hideAlertClick: function () {
      let _that = this;
      _that.isShowAlert = false;
    },
    cacheCleanClick: function (settingType) {
      let _that = this;
      _that.isShowAlert = true;

      // 不用校验是否普通模式
      // if (settingType == 5) {
      // 	_that.$emit("cacheCleanClick", null, _that.switching);
      // 	_that.hideAlertClick();
      // } else {
      // }

      if (settingType == 4 && _that.isCleaningCache) {
        settingType = 6;
      }

      if (_that.isCleaningCache) {
        _that.settingType = 6;
        _that.myWidth = "340px";
        _that.myHeight = "220px";
      } else if (settingType == 6) {
        _that.settingType = settingType;
        _that.myWidth = "340px";
        _that.myHeight = "220px";
        // _that.$emit("cacheCleanClick", null, _that.switching);
        _that.doCacheCleanClick();

        _that.initCleaning();
      } else {
        _that.settingType = settingType;
        _that.myWidth = "370px";
        _that.myHeight = "290px";
      }
    },
    doCacheCleanClick: function () {
      let _that = this;
      _that.cacheclean([
        _that.pid,
        _that.cleanSize,
        function (err, data) {
          if (data && data.rtn == 0) {
            // _that.tipText = "正在清除缓存，请稍后";
            // setTimeout(function () {
            // 	_that.tipText = "";
            // }, 2000);
          }
        },
      ]);

      // _that.hideAlertClick();
    },
    initCleaning: function () {
      let _that = this;
      let timestamp = parseInt(new Date().getTime() / 1000);
      _that.$common.localStorage.setItem(
        "jdxb-lastCacheCleanTimestamp",
        timestamp
      );
      _that.$common.localStorage.setItem(
        "jdxb-lastCacheCleanSize",
        _that.cacheused
      );
      _that.renderCacheBtn();
    },
    renderCacheBtn: function () {
      let _that = this;
      let lastCacheCleanTimestamp = _that.$common.localStorage.getItem(
        "jdxb-lastCacheCleanTimestamp"
      );
      lastCacheCleanTimestamp = lastCacheCleanTimestamp
        ? parseInt(lastCacheCleanTimestamp)
        : 0;
      let timestamp = parseInt(new Date().getTime() / 1000);

      let lastCacheCleanSize = _that.$common.localStorage.getItem(
        "jdxb-lastCacheCleanSize"
      );
      lastCacheCleanSize = lastCacheCleanSize
        ? parseInt(lastCacheCleanSize)
        : 0;

      if (
        lastCacheCleanSize == 0 ||
        _that.cacheused == 0 ||
        _that.cacheused / lastCacheCleanSize < 0.8
      ) {
        _that.isCleaningCache = false;
      } else if (timestamp - lastCacheCleanTimestamp < 60 * 30) {
        _that.isCleaningCache = true;
      } else {
        _that.isCleaningCache = false;
      }
    },
  },
  created: function () {
    let _that = this;
    _that.getSetting();
  },
};
</script>

<style lang="less" scoped>
.bg {
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.btn-open {
  position: absolute;
  right: 0px;
  top: 16px;
  transform: translate(0, -50%);
  width: 94px;
  height: 31px;
  line-height: 31px;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  background-color: #1f5de3;
  border-radius: 20px;
  font-weight: 700;
  cursor: pointer;
  background-color: #dce7ff;
  color: #153f9a;
  padding-right: 5px;

  .icon {
    position: absolute;
    right: 10px;
    top: -1px;
    width: 24px;
    height: 32px;
    background-image: url("../../assets/applications/a4.svg");
    .bg();
    background-size: 17px 17px;
  }
  .icon2 {
    top: -1px;
    background-image: url("../../assets/applications/a5.svg");
  }
}

.btn-open:hover {
  .uninstall-btn {
    display: block;
  }
}

.uninstall-btn {
  position: absolute;
  right: 0px;
  bottom: -30px;
  width: 99px;
  height: 31px;
  line-height: 31px;
  font-size: 12px;
  color: #7b88a7;
  text-align: center;
  background-color: #d9deea;
  border-radius: 20px;
  font-weight: 700;
  cursor: pointer;
  display: none;
}

.setting {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  background-color: rgba(0, 0, 0, 0.2);
  .setting-wrap {
    width: 345px;
    height: 500px;
    margin-left: -172px;
    margin-top: -250px;
    position: absolute;
    left: 50%;
    top: 50%;
    background-color: #ffffff;
    box-shadow: 0px 8px 16px rgba(61, 66, 73, 0.54);
    border-radius: 8px;
    padding-top: 1px;
    .close {
      position: absolute;
      right: 15px;
      top: 15px;
      width: 24px;
      height: 24px;
      background-image: url(../../assets/components/speed/setting/close-icon.svg);
      background-size: 100% 100%;
    }
    .close:hover {
      cursor: pointer;
    }
    .title {
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      color: #143977;
      margin-top: 20px;
    }
    .types {
      margin-top: 20px;
      text-align: center;
      .type-item {
        width: 124px;
        height: 42px;
        line-height: 42px;
        background: #f3f3f3;
        border: 1px solid #e4e4e4;
        border-radius: 4px;
        display: inline-block;
        vertical-align: top;
        margin: 0 6px;
        font-size: 16px;
        text-align: center;
        color: #666666;
        position: relative;
        .corner {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 20px;
          height: 20px;
          background-image: url(../../assets/components/speed/setting/select-icon.svg);
          background-size: 100% 100%;
          display: none;
        }
      }
      .type-item:hover,
      .active {
        background: #dbe5fb;
        border: 1px solid #2460e0;
        color: #2460e0;
        cursor: pointer;
        .corner {
          display: block;
        }
      }
    }
    .tips-wrap {
      width: 260px;
      height: 79px;
      margin: 0 auto;
      margin-top: 5px;
      background-image: url(../../assets/components/speed/setting/tips-bg.png);
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 23px 16px 0 16px;
      font-weight: 400;
      font-size: 13px;
      line-height: 20px;
      color: #666666;
    }
    .tips-wrap.tips-wrap2 {
      background-image: url(../../assets/components/speed/setting/tips-bg2.png);
    }
    .sub-title {
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #1a1a1a;
      width: 266px;
      margin: 0 auto;
      margin-top: 20px;
      position: relative;

      .sub-title-tips {
        font-weight: 400;
        font-size: 12px;
        line-height: 22px;
        color: #a2a2a2;
        float: right;
      }
      .clean-btn {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #2460e0;
        height: 22px;
        float: right;
        padding-left: 20px;
        background-image: url(../../assets/components/speed/setting/delete-icon.svg);
        background-size: 16px 16px;
        background-repeat: no-repeat;
        background-position: left center;
      }
      .clean-btn:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }
    .size-select {
      height: 22px;
      width: 266px;
      margin: 0 auto;
      margin-top: 18px;
      position: relative;
      .size-bg {
        position: absolute;
        width: 260px;
        height: 4px;
        top: 9px;
        left: 0;
        background-color: #eeeeee;
        .size-value {
          height: 4px;
          background-color: #1b5bff;
        }
      }
      .point {
        width: 14px;
        height: 14px;
        border-radius: 7px;
        background-color: #eeeeee;
        position: absolute;
        top: 4px;
        cursor: pointer;
      }
      .point:hover {
        background-color: #1b5bff;
      }
      .point.active {
        background-color: #1b5bff;
      }
      .point2 {
        left: 33%;
        margin-left: -7px;
      }
      .point3 {
        left: 66%;
        margin-left: -7px;
      }
      .point4 {
        left: 99%;
        margin-left: -7px;
      }
      .size-point {
        position: absolute;
        top: 0;
        width: 22px;
        height: 22px;
        border-radius: 11px;
        box-sizing: border-box;
        border: 3px solid #1b5bff;
        background-color: #ffffff;
        z-index: 3;
        left: 66%;
        margin-left: -11px;
      }
    }

    .select-tips {
      text-align: center;
      height: 20px;
      margin: 0 auto;
      .item {
        // text-align: left;
        display: inline-block;
        vertical-align: top;
        width: 24.5%;
        line-height: 20px;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
      }
    }

    .used-percent {
      width: 260px;
      margin: 0 auto;
      height: 12px;
      background-color: #eeeeee;
      margin-top: 8px;
      border-radius: 6px;
      overflow: hidden;
      .used-percent-value {
        width: 50%;
        height: 12px;
        background-color: #1b5bff;
        border-radius: 6px;
      }
    }

    .path {
      width: 266px;
      margin: 0 auto;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      margin-top: 4px;
      color: #999999;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .cache-clean-wrap {
    .title {
      margin-top: 14px;
      text-align: center;
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      color: #1a1a1a;
    }

    img {
      display: block;
      margin: 0 auto;
      margin-top: 26px;
      width: 58px;
      height: 58px;
    }
    .text-wrap {
      margin-top: 20px;
      margin-bottom: 36px;

      .text1 {
        margin: 0 auto;
        text-align: center;
        font-size: 15px;
        color: #666666;
        line-height: 22px;
      }
    }

    .btn1 {
      margin: 0 auto;
      width: 187px;
      height: 41px;
      line-height: 41px;
      background-color: #1f5de3;
      border-radius: 102px;
      text-align: center;
      color: #ffffff;
      font-weight: 700;
      font-size: 14px;
      cursor: pointer;
    }

    .clean-btns {
      text-align: center;

      .clean-btn-sure {
        margin: 0 auto;
        margin-left: 15px;
        border-radius: 20px;
        width: 130px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        color: #fefefe;
        text-align: center;
        background-color: #1f5de3;
        display: inline-block;
        vertical-align: top;
      }
      .clean-btn-sure:hover {
        opacity: 0.8;
        cursor: pointer;
      }

      .clean-btn-cancel {
        margin: 0 auto;
        border-radius: 20px;
        width: 130px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        color: rgba(153, 153, 153, 1);
        text-align: center;
        background-color: rgba(230, 230, 230, 1);
        display: inline-block;
        vertical-align: top;
      }
      .clean-btn-cancel:hover {
        opacity: 0.8;
        cursor: pointer;
      }
    }
  }

  .do-cache-clean-wrap {
    text-align: center;
    .text-wrap {
      margin: 0 auto;
      margin-top: 26px;
      padding-top: 16px;
      background-color: rgba(240, 175, 45, 0.08);
      width: 328px;
      height: 68px;
      box-sizing: border-box;
      text-align: left;

      .img-wrap {
        display: inline-block;
        margin-left: 14px;
        vertical-align: top;
        img {
          width: 36px;
          height: 36px;
        }
      }
      .text1 {
        display: inline-block;
        margin-left: 10px;
        width: 255px;
        font-size: 14px;
        color: #666666;
      }
    }
    .cache-clean-options {
      margin-top: 20px;
      div {
        display: inline-block;
        width: 82px;
        height: 27px;
        line-height: 27px;
        border-radius: 2px;
        border: 1px solid #cccccc;
        font-size: 14px;
        color: #666666;
        cursor: pointer;
        box-sizing: border-box;
      }
      .text2 {
        margin-left: 10px;
        margin-right: 10px;
      }
      .active {
        background-color: #f9c357;
        color: #f5f5f5;
        font-weight: 700;
        border: 1px solid #f9c357;
      }
    }

    .clear-cache-btn {
      margin: 0 auto;
      margin-top: 30px;
      width: 187px;
      height: 41px;
      line-height: 41px;
      border-radius: 102px;
      background-color: #1f5de3;
      font-size: 14px;
      font-weight: 700;
      color: #ffffff;
    }
    .clear-cache-btn:hover {
      // background-color: #1f5de3;
      cursor: pointer;
      opacity: 0.9;
    }

    .cleaning-tips {
      margin-top: 56px;
      text-align: center;
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      color: #1a1a1a;
    }

    .cleaning-sub-tips {
      margin-top: 30px;
      margin-bottom: -15px;
      text-align: center;
      font-size: 13px;
      line-height: 20px;
      color: #888888;
    }
  }
}
</style>